import 'fetch-polyfill';
import API from '../../APIconfig';

import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError
} from '../async/asyncActions';

import {
  DOWNLOAD_STATEMENT
} from './statementConstants';

import {
  toastr
} from 'react-redux-toastr';

import {
  exportCSVFile
} from '../../app/common/util';

export const downloadStatement = (csrfRequestIdentifier, token, fileName) => {
  return async dispatch => {
    try {
      // show loader
      dispatch(asyncActionStart('Downloading statement . . .', true, 'downloadstatement'));

      // pre configure
      const endDate = Math.round(new Date().getTime());
      let startDate = new Date();
      startDate.setMonth(startDate.getMonth() - 6);
      startDate = Math.round(startDate.getTime());

      // req construct
      const reqObject = {
        method: API.statement.method,
        credentials: 'include',
        mode: 'cors',
        body: JSON.stringify({
          token,
          "endDate": endDate,
          "startDate": startDate,
          "cursor": null
        }),
        headers: new Headers({
          'Content-type': 'application/json',
          csrfRequestIdentifier,
          fcChannel: API.fcChannel,
        }),
      };

      // final request
      const statement = await fetch(API.statement.url, reqObject).then(response => response.json());

      //handle response
      if (statement.transactions && Array.isArray(statement.transactions) && statement.transactions.length > 0) {

        // set first row or header for csf file
        const headers = {
          txnDate: "Date",
          txnDescription: 'Transaction Description', // remove commas to avoid errors
          orderId: "Order ID",
          txnId: "Transaction ID",
          txnType: "Transaction Type",
          txnAmount: "Transaction Amount",
          balance: "Closing Balance",
          comments: "Comments",
        };

        // unformatted
        const itemsNotFormatted = statement.transactions;

        // init
        const itemsFormatted = [];

        // Format incoming data
        itemsNotFormatted.forEach((item) => {
          itemsFormatted.push({
            txnDate: item.txnDate,
            txnDescription: item.txnDescription,
            orderId: item.orderId,
            txnId: item.txnId,
            txnType: item.txnType,
            txnAmount: item.txnAmount,
            balance: item.balance,
            comments: item.comments,
          });
        });



        // Export data as CSV file <UTIL>
        exportCSVFile(headers, itemsFormatted, fileName, function() {
          toastr.success('Statement', 'Successfully downloaded statement');
        });
      } else if (statement.transactions && Array.isArray(statement.transactions) && statement.transactions.length === 0) {
        toastr.error('Statement', `You have no transactions!`);
      } else {
        toastr.error('Statement', `Error while downloading statement, ${statement.errorMessage}`);
      }

      // dispatch action
      dispatch({
        type: DOWNLOAD_STATEMENT,
        payload: statement,
      });

      // hide loader
      dispatch(asyncActionFinish());
    } catch (error) {
      // handle error
      console.log(error);

      toastr.error('Statement', `Error while downloading statement`);

      // hide loader
      dispatch(asyncActionError());
    }
  };
};